/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const FullScreen: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="full-screen" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M528.9125 1171.13V1095.565H264.4775V831.13H188.9125V1171.13H528.9125zM188.9125 188.9124999999999V528.9125H264.4775V264.4775H528.9125V188.9124999999999H188.9125zM831.13 1171.13V1095.565H1095.565V831.13H1171.13V1171.13H831.13zM831.13 188.9124999999999V264.4775H1095.565V528.9125H1171.13V188.9124999999999H831.13z" : "M423.13 936.904V876.452H211.582V664.904H151.13V936.904H423.13zM151.13 151.13V423.13H211.582V211.582H423.13V151.13H151.13zM664.904 936.904V876.452H876.4520000000001V664.904H936.904V936.904H664.904zM664.904 151.13V211.582H876.4520000000001V423.13H936.904V151.13H664.904z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
FullScreen.displayName = `Blueprint5.Icon.FullScreen`;
export default FullScreen;
